import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {action, observable} from "mobx";
import Logger from "@intelingu/core/utils/Logger";
import {Form} from "@intelingu/core/components/form/Form";
import {Field} from "@intelingu/core/components/form/Field";
import {IsDefined} from "class-validator";
import {SubmitButton} from "../../partials/form/elements/SubmitButton";
import {TextInput} from "../../partials/form/elements/TextInput";
import {AuthStore} from "../../../stores/AuthStore";
import {lazyInject} from "@intelingu/core/IoC/container";
import {Redirect} from "react-router";
import {graphql} from "../../../configs/graphql.client";
import {MeComponent} from "../../../types.d";
import {WorkspaceStore} from "../../../stores/WorkspaceStore";

interface LoginPageProps {
    location?;
}

class LoginRequest {

    // @IsEmail()
    email: string;

    @IsDefined()
    password: string;

}

@observer export class LoginPage extends Component<LoginPageProps, any> {

    @lazyInject(AuthStore) authStore: AuthStore;
    @lazyInject(WorkspaceStore) workspaceStore: WorkspaceStore;

    @observable isError = false;
    @observable success = false;

    @action.bound async login(data: LoginRequest, done) {
        const { email, password } = data;

        try {
            await this.authStore.authorize(email, password);

            this.success = true;
        } catch (e) {
            this.isError = true;

            Logger.error(e);
        } finally {
            done();
        }
    }

    render() {
        const { location } = this.props;

        if (this.success) {
            return <MeComponent
                client={graphql.client}
                fetchPolicy={'network-only'}
                onCompleted={data => {
                    this.workspaceStore.user = data.me;
                }}
            >
                { (result) => result.data ? <Redirect to={`/`} /> : null }
            </MeComponent>;
        }

        const alert = location.state && location.state.alert;

        return <div className={'session-page'}>
            <h1 style={{ textAlign: 'center' }}>Team Area</h1>

            { alert && (
                <div className={'alert alert-primary'} style={{ marginTop: 20 }}>
                    { alert }
                </div>
            )}

            <div className={'sep'} />

            <Form validator={LoginRequest} onSubmit={this.login}>
                <div className={'form-group'}>
                    <label>Email / Username</label>

                    <Field
                        name={'email'}
                        render={props => <TextInput {...props} />}
                    />
                </div>

                <div className={'form-group'}>
                    <label>Password</label>

                    <Field
                        name={'password'}
                        render={props => <TextInput type={'password'} {...props} />}
                    />
                </div>

                { this.isError && (
                    <div className="alert alert-danger" style={{ display: 'block' }}>Wrong login or password</div>
                )}

                <div className={'form-group'} style={{ marginTop: 20 }}>
                    <Field submit render={props => <SubmitButton className={'outline'} {...props}>Log In</SubmitButton>} />
                </div>
            </Form>
        </div>
    }

}
